import React, { Component } from 'react';

import StringUtils from '../services/StringUtils.js';

import '../../css/MapFilter.css';

class MapFilter extends Component {

  constructor(props, context) {
    super(props, context);

    let state = this.stateFromProps(props)
    state.showFilters = false;
    state.selection = false;
    state.showEdges = false;
    state.selectedOption = undefined;

    this.state = state;

    this.onChange = props.onChange;
    this.selectAll = props.selectAll;
    this.selectNone = props.selectNone;
  }

  componentWillReceiveProps(newProps) {
    this.props = newProps;
    this.onChange = newProps.onChange;
    this.selectAll = newProps.selectAll;
    this.selectNone = newProps.selectNone;
    this.setState(this.stateFromProps(newProps));
  }

  stateFromProps(props) {

    let selectedTags = props.selectedTags || [];
    let selectedCountries = props.selectedCountries || [];
    let selectedGenders = props.selectedGenders || [];

    let genders = props.genders || [];
    let tags = props.tags || [];
    let countries = props.countries || [];

    genders = ['all'].concat(genders);
    tags = ['all'].concat(tags);
    countries = ['all'].concat(countries);

    return {
      selectedTags,
      selectedCountries,
      selectedGenders,
      genders,
      tags,
      countries
    };

  }

  currentQuery() {

    let query = {
      showEdges: this.state.showEdges,
      selection: this.state.selection,
      genders: this.state.selectedGenders,
      tags: this.state.selectedTags,
      countries: this.state.selectedCountries
    }
    
    return query;

  }

  toggleEdges() {
    let query = this.currentQuery();

    query.showEdges = !this.state.showEdges;
    this.setState({showEdges: query.showEdges});

    this.onChange(query);
  }

  toggleFilters() {
    this.setState({showFilters: !this.state.showFilters});
  }

  toggleSelection() {
    let query = this.currentQuery();

    query.selection = !this.state.selection;
    this.setState({selection: query.selection});

    this.onChange(query);
  }

  active(prop) {

    let isActive = this.state[prop];

    if (prop === 'male' || prop === 'female')
      isActive = this.state.genders.indexOf(prop) > -1;

    return isActive ? 'active' : '';
  }

  toggleTags() {
    this.setState({selectedOption: 'tags'});
  }

  toggleCountries() {
    this.setState({selectedOption: 'countries'});
  }

  toggleGenders() {
    this.setState({selectedOption: 'genders'});
  }

  isSelected(option) {
    return this.state.selectedOption === option;
  }

  select(option, element) {

    let choice = {};

    let elements = [element];

    if (element === 'all')
      elements = [];

    let selectedField = `selected${StringUtils.titleize(option)}`;

    choice[selectedField] = elements;
    choice['showFilters'] = false;

    this.setState(choice, () => {
      let query = this.currentQuery();
      this.onChange(query);
    });
  }

  optionItems(type, items) {

    let isSelected = (item) => {
      let elements = this.state[`selected${StringUtils.titleize(type)}`];
      if (item === 'all' && elements.length === 0)
        return true;

      return elements.indexOf(item) > -1;
    };

    items = items.slice(0,15).map((item) => {
      return (
        <li key={item} onClick={this.select.bind(this, type, item)} className={`${isSelected(item) ? 'active' : ''} clickable`}>
          {StringUtils.titleize(item)}
        </li>
      );
    });

    return (
      <ul className="options">
        {items}
      </ul>
    );

  }

  renderFilters() {

    if (!this.state.showFilters)
      return null;

    let countryOptions = this.optionItems('countries', this.state.countries);
    let tagOptions = this.optionItems('tags', this.state.tags);
    let genderOptions = this.optionItems('genders', this.state.genders);

    return (
      <div className="filters">
        <i onClick={this.toggleTags.bind(this)} className={`${this.isSelected('tags') ? 'active' : ''} fontastic icon-tag clickable`}></i>
        <i onClick={this.toggleCountries.bind(this)} className={`${this.isSelected('countries') ? 'active' : ''} fontastic icon-world clickable`}></i>
        <i onClick={this.toggleGenders.bind(this)} className={`${this.isSelected('genders') ? 'active' : ''} fontastic icon-gender-mixed clickable`}></i>
      
        {this.isSelected('tags') && tagOptions}
        {this.isSelected('countries') && countryOptions}
        {this.isSelected('genders') && genderOptions}

      </div>
    );
  }

  renderSelection() {
    
    if (!this.state.selection)
      return null;
    
    return (
      <div className="selectionOptions">
        <i onClick={this.selectAll.bind(this)} className="fontastic icon-select-all clickable"></i>
        <i onClick={this.selectNone.bind(this)} className="fontastic icon-select-none clickable"></i>
      </div>
    );

  }

  render() {

    return (
      <div id="mapFilter">
        
        <div className="menu">
          <i onClick={this.toggleFilters.bind(this)} className={`${this.active('showFilters')} filterToggle fontastic icon-filter clickable`}></i>
          <i onClick={this.toggleEdges.bind(this)} className={`${this.active('showEdges')} fontastic icon-connection clickable`}></i>
          <i onClick={this.toggleSelection.bind(this)} className={`${this.active('selection')} fontastic icon-selection clickable`}></i>
        </div>

        <div className="content">
        
        {this.renderFilters()}
        {this.renderSelection()}
        
        </div>

      </div>
    );
  }

}

export default MapFilter;



// WEBPACK FOOTER //
// ./src/js/components/MapFilter.jsx